export const QUOTE_TERMS_LIST = [
  {
    title: "Quotation Validity",
    label:
      "This quotation is valid for 30 calendar days from the date of issuance unless otherwise stated in writing. After this period, IPC Foundry Group reserves the right to revise pricing and delivery terms.",
  },
  {
    title: "Pricing",
    label:
      "All prices are quoted in U.S. Dollars unless otherwise specified and are based on the information provided at the time of quote. Pricing may be subject to adjustment due to fluctuations in material costs, alloy surcharges, or changes to scope or technical requirements. IPC foundry reserves the right to change pricing at time of PO.",
  },
  {
    title: "Delivery & Lead Time",
    label:
      "Lead times are estimates and are based on current production capacity at the time of quotation. Confirmed lead times will be provided at time of order acknowledgment. IPC Foundry Group is not liable for delays due to causes beyond its control, including supplier delays, force majeure, or customer changes.",
  },
  {
    title: "Tooling",
    label:
      "Tooling costs, if quoted, are non-recurring unless specifically stated. Payment terms for tooling are 50% due upon purchase order, 50% due upon tooling completion.",
  },
  {
    title: "Order Acceptance",
    label:
      "No order shall be binding unless formally accepted by IPC Foundry Group through an order acknowledgment. Acceptance is subject to credit approval.",
  },
  {
    title: "Payment Terms",
    label:
      "Standard payment terms are Net 30 days from date of invoice, unless otherwise agreed in writing. Late payments may be subject to a 1.5% monthly finance charge.",
  },
  {
    title: "Repair",
    label:
      "IPC Foundry Group reserves the right to upgrade and repair any castings unless specifically called out on the purchase order.",
  },
  {
    title: "Confidentiality",
    label:
      "All pricing, technical data, and commercial information are considered confidential and may not be disclosed to third parties without IPC's written consent.",
  },
  {
    title: "Governing Law",
    label:
      "This quotation and any resulting purchase orders shall be governed by the laws of the State of Utah, without regard to its conflict of law provisions.",
  },
];

export const QUOTE_NOTES = [
  "Sample part cost is equal to production pricing, plus quoted NRE fee",
  "MOQ is $2500.",
  "Subject to raw material pricing upon arrival of PO",
  "Subject to Terms and Conditions",
];
